import * as React from 'react'
import { UpgradeNowLink } from './UpgradeNowLink'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const UpgradeNowLinkExamples = () => {
  return (
    <div className="UpgradeNowLinkExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <UpgradeNowLink />
      </Provider>
    </div>
  )
}
